import type { CastId } from "../../engine";
import { CHARACTERS, DIALOGUE_PORTRAITS } from "../../shared/assets";
import type { LadoDeDialogo } from "./lado-dialogo";
import "./dialogue-visual.css";

function paletaDelTurno(speaker: CastId): "capi" | "luna" | "tomi" | "clara" | "beto" | "all" {
  return speaker;
}

interface RetratoDeDialogoProps {
  readonly speaker: CastId;
  readonly nombre: string;
  readonly compacto?: boolean;
}

export function RetratoDeDialogo({ speaker, nombre, compacto = false }: RetratoDeDialogoProps) {
  const clase = ["dialogo__retrato", compacto ? "dialogo__retrato--mini" : ""].filter(Boolean).join(" ");

  if (speaker === "all") {
    return (
      <span className={`${clase} dialogo__retrato--inicial`} aria-hidden="true">
        {nombre.slice(0, 1)}
      </span>
    );
  }

  return (
    <span className={clase}>
      <img
        className="dialogo__retrato-imagen"
        src={DIALOGUE_PORTRAITS[speaker]}
        alt=""
        width={320}
        height={320}
        decoding="async"
        onError={(evento) => {
          const imagen = evento.currentTarget;
          if (imagen.dataset.fallback !== "poster") {
            imagen.dataset.fallback = "poster";
            imagen.src = CHARACTERS[speaker].posterUrl;
          } else {
            imagen.hidden = true;
          }
        }}
      />
      <span className="dialogo__retrato-inicial" aria-hidden="true">
        {nombre.slice(0, 1)}
      </span>
    </span>
  );
}

interface IdentidadDeHablanteProps {
  readonly speaker: CastId;
  readonly nombre: string;
}

/** Identidad compacta reutilizable en preguntas que conservan opciones visibles. */
export function IdentidadDeHablante({ speaker, nombre }: IdentidadDeHablanteProps) {
  return (
    <span className="dialogo__identidad" data-paleta={paletaDelTurno(speaker)}>
      <RetratoDeDialogo speaker={speaker} nombre={nombre} compacto />
      <span className="dialogo__identidad-nombre">{nombre}</span>
    </span>
  );
}

interface TurnoDeDialogoProps {
  readonly speaker: CastId;
  readonly nombre: string;
  readonly texto: string;
  readonly lado: LadoDeDialogo;
  readonly actual?: boolean;
}

/** Voz única compartida por episodio, encuentros y feedback de minijuegos. */
export function TurnoDeDialogo({
  speaker,
  nombre,
  texto,
  lado,
  actual = true,
}: TurnoDeDialogoProps) {
  return (
    <article
      className={[
        "dialogo__turno",
        actual ? "dialogo__turno--actual" : "dialogo__turno--historial",
      ].join(" ")}
      data-lado={lado}
      data-paleta={paletaDelTurno(speaker)}
      aria-hidden={actual ? undefined : true}
    >
      <div className="dialogo__identidad-personaje">
        <RetratoDeDialogo speaker={speaker} nombre={nombre} />
        <span className="dialogo__nombre-personaje">{nombre}</span>
      </div>
      <div className="dialogo__globo">
        <p className="dialogo__texto">{texto}</p>
      </div>
    </article>
  );
}
